import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LogoEmpresa from '../assets/LogoEmpresa.png'

export default function Header() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // "servicos" | "produtos" | null

  // Acende "Serviços" / "Produtos" quando a rota atual é uma de suas subpáginas
  const servicosAtivo = location.pathname.startsWith("/servicos");
  const produtosAtivo = location.pathname.startsWith("/produtos");

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  // Header fica "scrolled" ao passar de 10px
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    handleScroll(); // aplica o estado correto já na primeira renderização
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fecha o drawer mobile automaticamente ao redimensionar pra desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setNavOpen(false);
        setOpenDropdown(null);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Dropdown por clique apenas no mobile (accordion — só um aberto por vez)
  const toggleDropdown = (name) => {
    if (window.innerWidth <= 768) {
      setOpenDropdown((prev) => (prev === name ? null : name));
    }
  };

  return (
    <header
      className={`header${scrolled ? " scrolled" : ""}`}
      id="siteHeader"
    >
      <div className="header__inner">
        <Link to="/">
          <img
            src={LogoEmpresa}
            alt="logo sepolTECH"
            className="logo"
          />
        </Link>

        {/* Correção: o CSS mobile procura por ".nav.open", não ".nav--open" */}
        <nav className={`nav${navOpen ? " open" : ""}`} id="mainNav">
          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}
            onClick={() => setNavOpen(false)}
          >
            Início
          </NavLink>
          <NavLink
            to="/sobre"
            className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}
            onClick={() => setNavOpen(false)}
          >
            Sobre
          </NavLink>

          <NavLink
            to="/cases"
            className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}
            onClick={() => setNavOpen(false)}
          >
            Cases
          </NavLink>

          <div className={`nav__item${openDropdown === "servicos" ? " open" : ""}`}>
            <button
              className={`nav__link${servicosAtivo ? " active" : ""}`}
              onClick={() => toggleDropdown("servicos")}
            >
              Serviços ▾
            </button>
            <div className="nav__dropdown">
              <Link to="/servicos/gestao-ti" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#0066FF" }} />
                Gestão de TI (MSP)
              </Link>
              <Link to="/servicos/rmm" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#4D94FF" }} />
                RMM / Endpoints
              </Link>
              <Link to="/servicos/suporte" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#0EA5E9" }} />
                Suporte Técnico
              </Link>
              <Link to="/servicos/acesso-remoto" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#00C2A0" }} />
                Acesso Remoto
              </Link>
              <Link to="/servicos/consultoria" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#8B90A0" }} />
                Consultoria &amp; Projetos
              </Link>
              <Link to="/portfolio" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#F59E0B" }} />
                Desenvolvimento de sites
              </Link>
            </div>
          </div>

          <div className={`nav__item${openDropdown === "produtos" ? " open" : ""}`}>
            <button
              className={`nav__link${produtosAtivo ? " active" : ""}`}
              onClick={() => toggleDropdown("produtos")}
            >
              Produtos ▾
            </button>
            <div className="nav__dropdown">
              <Link to="https://sepolhost.com.br/" target="_blank" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#E8530A" }} />
                sepolHOSTING
              </Link>
              <Link to="/produtos/sepol-drive" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#0091FF" }} />
                sepolDRIVE
              </Link>
              <Link to="/produtos/sepol-backup" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#3ABEFF" }} />
                sepolBACKUP
              </Link>
              <Link to="/produtos/sepol-chat" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#00C2A0" }} />
                sepolCHAT
              </Link>
              <Link to="/produtos/sepol-security" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#7B3FF2" }} />
                sepolSECURITY
              </Link>
              <Link to="/produtos/outsourcing-locacao" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#8B90A0" }} />
                Outsourcing &amp; Locação
              </Link>
              <div className="nav__dropdown-sep" />
              <Link to="/produtos/erp" className="nav__dropdown-link">
                <span className="dot" style={{ background: "#22C55E" }} />
                ERP Bruning
              </Link>
            </div>
          </div>

          <NavLink
            to="/faq"
            className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}
            onClick={() => setNavOpen(false)}
          >
            FAQ
          </NavLink>
          <NavLink
            to="/base-conhecimento"
            className={({ isActive }) => `nav__link${isActive ? " active" : ""}`}
            onClick={() => setNavOpen(false)}
          >
            Base de Conhecimento
          </NavLink>

          <div className="nav__actions">
            {usuario ? (
              <>
                <div className="user-chip">
                  <span className="user-chip__dot"></span>
                  Olá, {usuario.nome}
                </div>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={handleLogout}
                >
                  Sair
                </button>
              </>
            ) : (
              <Link to="/contato" className="btn btn-primary" onClick={() => setNavOpen(false)}>
                Fale Conosco
              </Link>
            )}
          </div>
        </nav>

        <button
          className={`nav__toggle${navOpen ? " open" : ""}`}
          id="navToggle"
          onClick={() => setNavOpen((open) => !open)}
          aria-expanded={navOpen}
          aria-label="Abrir menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}
